import { useContext } from 'react';

import { UserContext } from 'client/common/contexts/user';

export function useUser() {
    return useContext(UserContext);
}
